import { render, staticRenderFns } from "./calendar-facet-minimal.vue?vue&type=template&id=c95e4d1e&"
import script from "./calendar-facet-minimal.vue?vue&type=script&lang=js&"
export * from "./calendar-facet-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports